import { createContext, useState, useContext, useEffect } from "react";
import StudentsData from "../data/StudentsData";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Estado de carga

  useEffect(() => {
    const storedUser = localStorage.getItem("loggedInUser");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false); // Terminó de cargar
  }, []);

  const login = (email, password) => {
    const student = StudentsData.find(
      (student) => student.email === email && student.password === password
    );

    if (student) {
      setUser(student);
      localStorage.setItem("loggedInUser", JSON.stringify(student));
      return true;
    }
    return false;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("loggedInUser");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
